// extracted by mini-css-extract-plugin
export default {"anchorWithStickyNavbar":"anchorWithStickyNavbar_31ik","anchorWithHideOnScrollNavbar":"anchorWithHideOnScrollNavbar_3R7-"};